import { FlowDefinitionState } from 'flow-schema';

import { Tag, type TagProps, api } from 'common';

const TagPropsByState: Record<api.FlowDefinition.FlowDefinition['state'], TagProps> = {
  [FlowDefinitionState.Draft]: { color: 'primary' },
  [FlowDefinitionState.Review]: { color: 'primary' },
  [FlowDefinitionState.Published]: { color: 'success' },
  [FlowDefinitionState.Superseded]: { color: 'warning' },
  [FlowDefinitionState.SoftDeleted]: { color: 'error' },
};

interface FlowDefinitionStateTagProps {
  state: api.FlowDefinition.FlowDefinition['state'];
}

export function FlowDefinitionStateTag(props: FlowDefinitionStateTagProps) {
  const { state } = props;
  return (
    <Tag {...TagPropsByState[state]}>{api.FlowDefinition.FlowDefinitionStateProps[state].name}</Tag>
  );
}
